import {
    NinchatChannelMemberAttributes, NinchatUserAttributes,
} from 'api/types/attributes'


import {
    NinchatEmbedConfig,
    NinchatEnvironmentConfig,
} from 'embed/types'


import React, {createContext} from 'react'
import {NinchatAttributes} from 'api/types'


export type EmbedContextValue = (NinchatEnvironmentConfig & NinchatEmbedConfig) | undefined

// eslint-disable-next-line no-extra-parens
export const EmbedContext = createContext<(EmbedContextValue & EmbedState) | undefined>(undefined)

const {Provider} = EmbedContext

export interface EmbedStateValue {
    chatBacklogRef?: React.RefObject<HTMLDivElement> | null
    chatTextareaRef?: React.RefObject<HTMLTextAreaElement> | null
    lightBox: {
        open: boolean
        imageSrc: string | null
        imageAttr: NinchatAttributes.NinchatFileAttributes | null
        options: {
            downloadDisabled?: boolean
        }
    }
    heroFullVisible?: boolean
    heroFullAbsoluteVisible?: boolean
    lastChannelId?: string
    mute?: boolean
    channelMembers?: Array<{
        details: NinchatUserAttributes;
        id: string;
        member_attrs?: NinchatChannelMemberAttributes
    }>,
    // store information also about channel member who quit channel
    channelMembersAll?: Array<{
        details: NinchatUserAttributes;
        id: string;
        member_attrs?: NinchatChannelMemberAttributes
    }>
    error: {message?: string, title?: string} | null
    connectionError: {message?: string, title?: string} | null
}
export interface EmbedState {
    embedState: EmbedStateValue
    setEmbedState: React.Dispatch<React.SetStateAction<EmbedStateValue>>
    closeEmbedRef: React.MutableRefObject<((clearData?: boolean) => void) | null>
}

export const EmbedProvider = ({
    children, value,
}: any) => {
    const [embedState, setEmbedState] = React.useState<EmbedStateValue>({
        channelMembers: [],
        chatBacklogRef: undefined,
        chatTextareaRef: undefined,
        connectionError: null,
        error: null,
        heroFullAbsoluteVisible: false,
        heroFullVisible: false,
        lastChannelId: '',
        lightBox: {
            imageAttr: null,
            imageSrc: null,
            open: false,
            options: {downloadDisabled: false},
        },
        mute: true,
    })

    // eslint-disable-next-line no-extra-parens
    const closeEmbedRef = React.useRef<((clearData?: boolean) => void) | null>(null)

    return (
        <Provider value={{
            ...value,
            closeEmbedRef,
            embedState,
            setEmbedState,
        }}
        >
            {children}
        </Provider>
    )
}

